'use client';

import { APP_PLATFORM } from '@/utils/constants';
import { getAppPlatform } from '../platform';
import { PlatformBridgeAndroid } from './platform/android';
import { PlatformBridgeIos } from './platform/ios';
import { PlatformBridgeVoid } from './platform/void';
import { PlatformBridgeXsell } from './platform/xsell';

export const getPlatformBridge = () => {
    const platform = getAppPlatform();
    let bridge = null;

    // Add more bridges when they are implemented
    switch (platform) {
        case APP_PLATFORM.Android:
            bridge = new PlatformBridgeAndroid();
            break;
        case APP_PLATFORM.Xsell:
            bridge = new PlatformBridgeXsell();
            break;
        case APP_PLATFORM.Ios:
            bridge = new PlatformBridgeIos();
            break;
    }

    if (!bridge?.isCompatible()) {
        console.warn(`Bridge not found or is not compatible(${platform}) returning PlatformVoidBridge`);
        return new PlatformBridgeVoid();
    }

    if (process.env.NODE_ENV === 'development') {
        bridge.debug();
    }

    return bridge;
};
